module.exports = __webpack_public_path__ + "static/media/VET.55e6062e.png";